
import { createStore, applyMiddleware,combineReducers } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import userReducer from "./reducer/user";
import mobileFinnance from "./reducer/mobileFinnance";
import account from "./reducer/account";
import client from "./reducer/client";
import transaction from "./reducer/transaction";


const rootReducer = combineReducers({
    user:userReducer,
    mobileFinnance,
    account,
    client,
    transaction
});


const store = createStore(
    rootReducer,
    composeWithDevTools(applyMiddleware(thunk))
);

export default store;